import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "@/components/ui/select";
import { useApp } from "@/context/AppContext";
import { fmtPeriod } from "@/lib/api";

export const PeriodSelect = () => {
  const { periods, period, setPeriod } = useApp();
  if (!periods.length) {
    return <span className="text-sm text-slate-500" data-testid="period-empty">No uploads yet</span>;
  }
  return (
    <Select value={period} onValueChange={setPeriod}>
      <SelectTrigger className="w-44 h-9 rounded-sm bg-white font-mono text-sm" data-testid="period-select">
        <SelectValue placeholder="Month end" />
      </SelectTrigger>
      <SelectContent>
        {periods.map((p) => (
          <SelectItem key={p} value={p} data-testid={`period-option-${p}`}>
            {fmtPeriod(p)}
          </SelectItem>
        ))}
      </SelectContent>
    </Select>
  );
};
